export const TAGS_UPDATED_IN_SELECTION = "entry_add_modal/tags_updated_in_selection";
export const DONE_EDITING = "entry_add_modal/done_editing";
export const CANCEL_ADDING = "entry_add_modal/canel_editing";
export const OPEN_MODAL = "entry_add_modal/open_modal";
export const ENTRY_REMOVE = "entry_add_moda/entry_remove";



// WEBPACK FOOTER //
// ./src/scenes/EntriesAddModal/actionTypes.js